// Channels grouped by deposit type
export const channels = {
  bank: [
    {
      id: 1,
      name: "Unionbank",
      logo: "/images/icon/bank/ub-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "UBP",
    },
    {
      id: 2,
      name: "Metrobank",
      logo: "/images/icon/bank/metrobank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "MET",
    },
    {
      id: 3,
      name: "BDO",
      logo: "/images/icon/bank/bdo-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BDO",
    },
    {
      id: 4,
      name: "BPI",
      logo: "/images/icon/bank/bpi-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BPI",
    },
    {
      id: 5,
      name: "Maybank",
      logo: "/images/icon/bank/maybank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "MBP",
    },
    {
      id: 6,
      name: "PS Bank",
      logo: "/images/icon/bank/psbank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PSB",
    },
    {
      id: 7,
      name: "RCBC",
      logo: "/images/icon/bank/rcbc-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "RCBC",
    },
    {
      id: 8,
      name: "Bank of Commerce",
      logo: "/images/icon/bank/bank-commerce-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BOC",
    },
    {
      id: 9,
      name: "Chinabank",
      logo: "/images/icon/bank/chinabank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CBC",
    },
    {
      id: 10,
      name: "Robinsons Bank",
      logo: "/images/icon/bank/robinsons-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "RSB",
    },
    {
      id: 11,
      name: "Security Bank",
      logo: "/images/icon/bank/security-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SBC",
    },
    {
      id: 12,
      name: "Asia United Bank",
      logo: "/images/icon/bank/asia-united-bank-logo copy.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "AUB",
    },
    {
      id: 13,
      name: "Landbank",
      logo: "/images/icon/bank/landbank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "LBP",
    },
    {
      id: 14,
      name: "Equicom Savings Bank",
      logo: "/images/icon/bank/equicom-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "EQB",
    },
    {
      id: 15,
      name: "PNB Bank",
      logo: "/images/icon/bank/pnb-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PNB",
    },
    {
      id: 16,
      name: "Philippine Trust Company",
      logo: "/images/icon/bank/philippine-trust-company-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PTC",
    },
    {
      id: 17,
      name: "Philippine Veterans Bank",
      logo: "/images/icon/bank/philippine-veterans-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PVB",
    },
    {
      id: 18,
      name: "UCPB",
      logo: "/images/icon/bank/ucpb-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "UCPB",
    },
    {
      id: 19,
      name: "ISLA Bank",
      logo: "/images/icon/bank/isla-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "IBI",
    },
    {
      id: 20,
      name: "Malayan Bank",
      logo: "/images/icon/bank/malayan-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "MSB",
    },
    {
      id: 21,
      name: "Partner Rural Bank",
      logo: "/images/icon/bank/partner-rural-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PAR",
    },
    {
      id: 22,
      name: "Philippine Business Bank",
      logo: "/images/icon/bank/pbb-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PBB",
    },
    {
      id: 23,
      name: "QCRB Bank",
      logo: "/images/icon/bank/qcrb-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "QRB",
    },
    {
      id: 24,
      name: "Sun Savings Bank",
      logo: "/images/icon/bank/sun-saving-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SSB",
    },
    {
      id: 25,
      name: "Bangko Mabuhay",
      logo: "/images/icon/bank/banko-mabuhay-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BMB",
    },
    {
      id: 26,
      name: "Citystate Savings Bank",
      logo: "/images/icon/bank/cs-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CSB",
    },
    {
      id: 27,
      name: "Dungganon Bank",
      logo: "/images/icon/bank/dungganon-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "DBI",
    },
    {
      id: 28,
      name: "East West Rural Bank",
      logo: "/images/icon/bank/eastwest-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "EWR",
    },
    {
      id: 29,
      name: "Wealth Development Bank",
      logo: "/images/icon/bank/WDB-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "EWR",
    },
    {
      id: 30,
      name: "CARD Bank",
      logo: "/images/icon/bank/card-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CRD",
    },
    {
      id: 31,
      name: "Ctbc Bank (Philippines) Corp.",
      logo: "/images/icon/bank/ctbc-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CTBC",
    },
    {
      id: 32,
      name: "East West Banking Corporation",
      logo: "/images/icon/bank/east-west-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "EWB",
    },
    {
      id: 33,
      name: "Sterling Bank Of Asia",
      logo: "/images/icon/bank/sterling-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SBA",
    },
    {
      id: 34,
      name: "China Bank Savings, Inc",
      logo: "/images/icon/bank/cbc-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CBS",
    },
    {
      id: 35,
      name: "Development Bank of the Philippines",
      logo: "/images/icon/bank/dbp-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "DBP",
    },
    {
      id: 36,
      name: "JP Morgan Chase Bank, N.A.",
      logo: "/images/icon/bank/chase-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "JPM",
    },
    {
      id: 37,
      name: "BPI Direct BanKO, Inc., A Savings Bank",
      logo: "/images/icon/bank/bpi-direct-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BPIDB",
    },
    {
      id: 38,
      name: "RCBC Savings Bank Inc.",
      logo: "/images/icon/bank/rcbc-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "RSBI",
    },
    {
      id: 39,
      name: "Cebuana Lhuillier Rural Bank, Inc",
      logo: "/images/icon/bank/cebuana-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CEBRUR",
    },
    {
      id: 40,
      name: "Producers Bank",
      logo: "/images/icon/bank/producers-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PRB",
    },
    {
      id: 41,
      name: "Queen City Development Bank, Inc.",
      logo: "/images/icon/bank/queen-city-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "QCB",
    },
    {
      id: 42,
      name: "ING\tING Bank N.V.",
      logo: "/images/icon/bank/ing-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "ING",
    },
    {
      id: 43,
      name: "Starpay Corporation",
      logo: "/images/icon/bank/starpay-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SPY",
    },
    {
      id: 44,
      name: "Yuanta Savings Ban",
      logo: "/images/icon/bank/yuanta-saving-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "YUANSB",
    },
    {
      id: 45,
      name: "UCPB Savings bank",
      logo: "/images/icon/bank/ucpb-savings-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "UCBSB",
    },
    {
      id: 46,
      name: "Binangonan Rural Bank (BRBDigital)",
      logo: "/images/icon/bank/brb-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "BRB",
    },
    {
      id: 47,
      name: "AllBank Inc.",
      logo: "/images/icon/bank/allbank-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "ABP",
    },
    {
      id: 48,
      name: "RURAL BANK OF GUINOBATAN, INC.",
      logo: "/images/icon/bank/rural-bank-guinobatan-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "RBG",
    },
    {
      id: 49,
      name: "CAMALIG BANK",
      logo: "/images/icon/bank/camalig-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CMG",
    },
    {
      id: 50,
      name: "Philippine Bank of Communications",
      logo: "/images/icon/bank/pbcom-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PBCOM",
    },
    {
      id: 51,
      name: "CIMB Bank Philippines, Inc.",
      logo: "/images/icon/bank/cimb-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "CIMB",
    },
    {
      id: 52,
      name: "GoTyme Bank Corporation",
      logo: "/images/icon/bank/go-tyme-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "GTB",
    },
    {
      id: 53,
      name: "GCash",
      logo: "/images/icon/bank/gcash-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "GCASH",
    },
    {
      id: 54,
      name: "COINS",
      logo: "/images/icon/bank/coins-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "COINS",
    },
    {
      id: 55,
      name: "Maya",
      logo: "/images/icon/bank/maya-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "PAYMAYA",
    },
    {
      id: 56,
      name: "GRABPAY",
      logo: "/images/icon/bank/grab-pay-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "GRABPAY",
    },
    {
      id: 57,
      name: "SHOPEE",
      logo: "/images/icon/bank/shopee-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SHOPEE",
    },
    {
      id: 58,
      name: "OMNIPAY",
      logo: "/images/icon/bank/omnipay-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "OMNIPAY",
    },
    {
      id: 59,
      name: "Maribank",
      logo: "/images/icon/bank/sea-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "SEA",
    },
    {
      id: 60,
      name: "ONB",
      logo: "/images/icon/bank/one-network-bank-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "bank",
      onSubmit: "handleBankSubmit",
      mbc: "ONB",
    },
  ],

  ewallet: [
    {
      id: 1,
      name: "GCash",
      onClick: "open_ewallet",
      logo: "/images/icon/bank/gcash-logo.webp",
      onSubmit: "handleGcashSubmit",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "gcash",
      mbc: "gcash",
    },
    {
      id: 2,
      name: "Gcash | Maya | Bank QRPH",
      onClick: "open_ewallet",
      logo: "/images/icon/bank/qrph-logo.webp",
      cmd: "deposit-request",
      cmd2: "deposit-request",
      method: "qrph",
    },
    {
      id: 3,
      name: "Maya",
      onClick: "open_ewallet",
      logo: "/images/icon/bank/maya-logo.webp",
      onSubmit: "handleMayaSubmit",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      method: "maya",
      mbc: "maya",
      pm: 3,
    },
    {
      id: 4,
      name: "FortunePay",
      onClick: "open_ewallet",
      logo: "/images/icon/bank/fortune-pay-logo.webp",
      cmd: "withdrawal-request",
      cmd2: "deposit-request",
      onSubmit: "handleFortunePaySubmit",
      method: "fortunepay",
      method2: "bank",
      mbc: "FortunePay",
      pm: 3,
    },
  ],
  crypto: [
    {
      id: 1,
      name: "TRC20-USDT",
      onClick: "open_crypto",
      logo: "/images/icon/bank/trc-logo.webp",
      cmd: "WithdrawRequestDirepay",
      onSubmit: "handleCryptoSubmit",
      mbc: "DirePay",
      cmd2: "direpayDeposit",
    },
    {
      id: 2,
      name: "ERC20-USDT",
      onClick: "open_crypto",
      logo: "/images/icon/bank/eth-logo.webp",
      cmd2: "direpayDeposit",
    },
    {
      id: 3,
      name: "TRC20-USDC",
      onClick: "open_crypto",
      logo: "/images/icon/bank/trc-logo.webp",
      cmd2: "direpayDeposit",
    },
    {
      id: 4,
      name: "ERC20-USDC",
      onClick: "open_crypto",
      logo: "/images/icon/bank/eth-logo.webp",
      cmd2: "direpayDeposit",
    },
    {
      id: 5,
      name: "BTC",
      onClick: "open_crypto",
      logo: "/images/icon/bank/bitcoin-logo.webp",
      cmd2: "direpayDeposit",
    },
    {
      id: 6,
      name: "ETH",
      onClick: "open_crypto",
      logo: "/images/icon/bank/eth-logo.webp",
      cmd2: "direpayDeposit",
    },
  ],
}

export const depositChannel = [
  {
    id: 2,
    name: "E-Wallet",
    onClick: "ewallet_selection",
    icon: "/images/icon/bank/e-wallet-logo.webp",
  },
  {
    id: 3,
    name: "Crypto",
    onClick: "crypto_selection",
    icon: "/images/icon/bank/bitcoin-logo.webp",
  },
  {
    id: 4,
    name: "Over the Counter",
    onClick: "otc_selection",
    icon: "/images/icon/bank/fortune-pay-logo.webp",
  },
  // {
  //   id: 5,
  //   name: "Vouchers",
  //   onClick: "voucher_selection",
  //   icon: "/images/icon/bank/voucher-logo.webp",
  // },
  {
    id: 1,
    name: "Bank (Maintenance)",
    status: "(Offline)",
    onClick: "bank_selection",
    icon: "/images/icon/bank/all-bank-logo.webp",
  },
]
